import { observer } from 'mobx-react';

import './style.scss';
import SectionTitle from '../../../../../components/Titles/SectionTitle';
import StepComponent from './StepFlowComponent';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useStore } from '../../../../../core/utils/hook';

const PecStepTopPage = observer(() => {
    // store
    const {
        settingTopPageStore: { isPreview }
    } = useStore();

    return (
        <section id='id-section-pec' className='section-pec'>
            <div className="section-pec-curve">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 134"
                    preserveAspectRatio="none"
                >
                    <path d="M0,10 C480,134 960,134 1440,10 L1440,0 L0,0 Z" fill="" />
                </svg>
            </div>

            <div className='container'>
                <div className='section-pec-title'>
                    <SectionTitle title={'PECS単位反映までの５Steps'} />
                </div>

                <StepComponent />

                {/* Note */}
                <div className='pec-note'>
                    <div className='pec-note-container'>
                        公益財団法人日本薬剤師研修センター（G01）のPECS（薬剤師研修・認定電子システム）対応
                        <br />
                        ※単位申請にはPECSの事前登録が必要です。
                        <br className='d-block d-sm-none' />
                        <Link
                            to={isPreview ? undefined : 'https://pecs.jpec.or.jp/_/pharmacist/'}
                            target='_blank'
                            className='link-text'
                            onClick={(e) => {
                                if (isPreview) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            PECSの登録はこちら
                            <ChevronRight size={16} strokeWidth={2} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
})

export default PecStepTopPage;
